<template>
    <div>
        <rkm-list
            :items="data.form.pedidosExames"
            hide-filters
            hide-pagination
        >
            <template v-slot:leading="{ item }">
                <div
                    v-if="item.urgente"
                    title="Urgente"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon
                        color="danger"
                        icon="exclamation-circle"
                    />
                </div>
            </template>

            <template v-slot="{ item }">
                <rkm-row>
                    <rkm-col>
                        <strong>Profissional:</strong> {{ item.lotacao.profissional.nome }} - <strong>CBO:</strong> {{ item.lotacao.ocupacao.codigo }}
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <strong>Justificativa:</strong> {{ item.justificativa }}
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <strong>Data da Solicitação:</strong> {{item.dataSolicitacao ? item.dataSolicitacao : item.exames[0].dataSolicitacao  }}
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:trailling="{ item }">
                <template
                    v-if="!Number.isInteger(item.id) || (Number.isInteger(item.id) && item.files.length === 0)"
                >
                    <rkm-button
                        :disabled="Number.isInteger(item.id)"
                        @click.stop="$emit('edit', item)"
                        color="primary"
                        title="Editar"
                        small
                    >
                        <rkm-icon icon="pen" />
                    </rkm-button>

                    <rkm-button
                        :disabled="Number.isInteger(item.id)"
                        @click.stop="handleDestroy(item)"
                        color="danger"
                        title="Excluir"
                        small
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>

                <template v-else>
                    <rkm-button
                        v-if="item.files.length"
                        @click.stop="laudos(item.id)"
                        color="primary"
                        title="Visualizar laudo(s)"
                        small
                    >
                        <rkm-icon icon="file-invoice" />
                    </rkm-button>
                </template>
            </template>

            <template v-slot:collapse="{ item }">
                <rkm-list-group class="rkm-list-group">
                    <rkm-list-group-item
                        v-for="exame in item.exames"
                        v-bind:key="exame.id"
                    >
                        <rkm-row class="align-items-center">
                            <rkm-col class="flex-grow-1">
                                <div>{{ exame.codigo | formatProcedimento }} - <strong>{{ exame.nome }}</strong></div>
                            </rkm-col>

                            <rkm-col cols="auto">
                               {{ exame.status.nome }}
                            </rkm-col>
                        </rkm-row>
                    </rkm-list-group-item>
                </rkm-list-group>
            </template>
        </rkm-list>

        <ModalLaudos
            ref="modalLaudos"
            :data="data"
        />
    </div>
</template>

<script>
// Components.
import ModalLaudos from './components/Modal'

// Filters.
import formats from '@/filters/formats'

export default {
    components: {
        ModalLaudos
    },
    filters: {
        ...formats,
    },
    methods: {
        handleDestroy(item) {
            const destroy = () => new Promise(resolve => {
                const index = this.data.form.pedidosExames.findIndex(pedidoExame => pedidoExame.id === item.id)
                this.data.model.pedidosExames = []
                resolve(this.data.form.pedidosExames.splice(index, 1))
            })

            this.showDeleteConfirmation('Tem certeza que deseja excluir?', destroy)
        },
        laudos(pedidoExameId) {

            this.$refs.modalLaudos.open(pedidoExameId)
        }
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>